export const oauthValidateDeveloperPermissions = "/oauth/validate_developer_permissions";
